/**
 * 自助查询接口
 * @author： xuyd
 * @date：2024-05-02
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'
const serviceModule = context.sunflower

export default {

  /**
   * 检索列表
   */
  searchList: (params) => {
    return request.post(serviceModule + "/datasvc/sqlQuery/search", params);
  },

  /**
   * 获取信息
   */
  getInfo: (id) => {
    let params = {id: id}
    return request.get(serviceModule + "/datasvc/sqlQuery/info/get", {params});
  },

  /**
   * 添加信息
   */
  addInfo: (params) => {
    return request.post(serviceModule + "/datasvc/sqlQuery/info/add", params);
  },
  /**
   * 保存信息
   */
  saveInfo: (params) => {
    return request.post(serviceModule + "/datasvc/sqlQuery/info/save", params);
  },

  /**
   * 删除
   * @param id id
   */
  deleteInfo: (id) => {
    return request.get(serviceModule + "/datasvc/sqlQuery/delete?id=" + id);
  },

  /**
   * 执行API/SQL
   *
   * @param params
   */
  execute: (params) => {
    return request.post(serviceModule + "/datasvc/sqlQuery/execute", params);
  },

}
